export default {
  statuses: {
    canceled: 'Cancelado',
    pending: 'Pendientes',
    in_progress: 'En curso',
    terminated: 'Completado',
  },
  fields: {
    hour: 'Hora',
    status: 'Estado',
    start_address: 'Dir inicial',
    end_address: 'Dir final',
    phone: 'Teléfono',
    name: 'Nombre',
    driver: 'Conductor',
    driver_name: 'Nombre Conductor',
    lat: 'Latitud',
    lng: 'Longitud',
    comment: 'Comentario',
    time: 'Tiempo',
    fee: 'Valor',
    deducted: 'Descontado',
    fee_multiplier: 'Multiplicador de tarifa',
    distance: 'Distancia',
    WpMessages: 'Mensajes',
    WpActions: 'Acciones',
    origin: 'Origen',
    arrived_at: 'Llegada',
    trip_started_at: 'Inicio del viaje',
    trip_ended_at: 'Fin del viaje',
    wait_for_arrival: 'Espera de asignación',
    wait_for_pickup: 'Espera en recogida',
    trip_duration: 'Duración del viaje',
  },
  origin: {
    admin: 'Panel admin',
    bot: 'Bot WhatsApp',
    test: 'Prueba',
    driver: 'Conductor',
    unknown: 'Sin identificar',
  },
  labels: {
    code: 'Código',
    phone: 'Teléfono',
    name: 'Nombre',
    start_address: 'Dirección inicial',
    end_address: 'Dirección final',
    comment: 'Comentario',
    count: 'Cant.',
    line: 'Línea',
    test_toggle: 'Servicio de prueba',
    target_driver: 'Conductor destino',
  },
  edit_start_address: 'Editar dirección inicial',
  current_start_address: 'Dirección inicial actual',
  self_service_trip: 'Viaje de autoservicio',
  edit_comment: 'Editar comentario',
  current_comment: 'Comentario actual',
  placeholders: {
    end_address_optional: 'Ingresa dirección de destino (opcional)',
    phone: '300 000 0000',
    name: 'Nombre del pasajero',
    start_address: 'Punto de recogida',
    end_address: 'Destino (opcional)',
    comment: 'Nota adicional',
  },
  history: 'Historial',
  total: 'Total',
  pending_title: 'Servicios pendientes',
  in_progress_title: 'Servicios en curso',
  title: 'Servicio | Servicios',
  route_integrity: {
    tab: 'Integridad de ruta',
    title: 'Reporte de integridad de ruta',
    helper_text: 'Los viajes marcados son evidencia para revisión, no una prueba de manipulación. Pondera la proporción junto con el total de viajes antes de sacar conclusiones.',
    fields: {
      driver: 'Conductor',
      total_trips: 'Viajes totales',
      flagged_trips: 'Viajes marcados',
      flagged_trips_tooltip: 'Un viaje marcado es un viaje finalizado que sí se inició por el flujo de viaje, pero terminó sin una ruta utilizable (ruta vacía o ausente) o con una distancia registrada de cero — un patrón compatible con supresión de GPS. Es evidencia para revisión, no una prueba.',
      flagged_ratio: 'Proporción marcada',
      flagged_ratio_tooltip: 'Es la proporción de viajes marcados sobre el total de viajes contabilizados del conductor en el rango, expresada en porcentaje. Analízala junto con el total de viajes: 1/1 (100%) no es lo mismo que 7/10.',
    },
    empty_state: 'No hay viajes contabilizados en el rango de fechas seleccionado.',
    drilldown_title: 'Viajes marcados — {driver}',
  },
  messages: {
    new_client: 'El cliente no existe, por lo que se ha creado uno nuevo',
    no_start_loc: 'Debe seleccionar un lugar!',
    driver_assigned: 'El servicio tiene un conductor asignado',
    has_applicants: 'No se puede reiniciar el servicio porque tiene conductores postulados en el momento',
    start_address_updated: 'Dirección de recogida actualizada',
    branch_required: 'Seleccione una sucursal para actualizar la dirección de recogida',
    comment_updated: 'Comentario actualizado',
    test_driver_required: 'Debe seleccionar un conductor para el servicio de prueba',
    test_notice: 'Este es un servicio de prueba: solo será visible para el conductor seleccionado y no generará cobros al conductor.',
  }
}
